import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "work-schedule-panel",
      class: { "work-schedule-panel--mobile": _setup.isMobile },
    },
    [
      _vm.isLoading && !_vm.schedule
        ? _c(_setup.WorkScheduleSkeleton)
        : _vm.schedule
        ? [
            _c(
              "div",
              { staticClass: "work-schedule-panel__days" },
              _vm._l(_setup.scheduleDays, function (day) {
                return _c(
                  "div",
                  {
                    key: day,
                    staticClass: "work-schedule-panel__day",
                    class: {
                      "text-subtitle-1 work-schedule-panel__day--current":
                        day === _vm.schedule.now_weekday_translit,
                      "text-body-1": day !== _vm.schedule.now_weekday_translit,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "work-schedule-panel__cell work-schedule-panel__cell--day",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _setup.tStatic(_vm.schedule.full_days[day])
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "work-schedule-panel__cell work-schedule-panel__cell--time",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _setup.tStatic(_vm.schedule.schedule_days[day])
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.schedule.lpu_exceptions.length
              ? [
                  !_setup.isMobile
                    ? _c(VDivider, {
                        staticClass: "work-schedule-panel__divider",
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { class: { "mt-6": _setup.isMobile } }, [
                    _c(
                      "div",
                      {
                        staticClass: "text--text",
                        class: _setup.isMobile
                          ? "text-h6 mb-4"
                          : "text-subtitle-1",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.holidaysTitle) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "work-schedule-panel__days" },
                      _vm._l(
                        _vm.schedule.lpu_exceptions,
                        function (exception, index) {
                          return _c(
                            "div",
                            {
                              key: `holiday-${index}`,
                              staticClass:
                                "work-schedule-panel__day text-body-1",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "work-schedule-panel__cell work-schedule-panel__cell--day",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_setup.tStatic(exception.date)) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "work-schedule-panel__cell work-schedule-panel__cell--time",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_setup.tStatic(exception.time)) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }